/*eslint no-unused-vars:0*/ //This is necessary because React is necessary for the Route component but it isn't explicitly used
import { Route, NotFoundRoute, DefaultRoute, Redirect } from "react-router"; //DefaultRoute, Link
import React from "react";

import App from "../views/Handler";
import App404 from "../views/NotFound";
import Root from "../views/anonymous/views/root/Handler";

import YourHome from "../views/anonymous/views/in-the-home/Handler";
import Features from "../views/anonymous/views/features/Handler";
import Technology from "../views/anonymous/views/technology/Handler";
import Pro from "../views/anonymous/views/pro/Handler";
import Help from "../views/anonymous/views/help/Handler";

import OurStory from "../views/anonymous/views/our-story/Handler";
import Jobs from "../views/anonymous/views/jobs/Handler";
import Press from "../views/anonymous/views/press/Handler";
import AppRoute from "../views/anonymous/views/app/Handler";
import Legal from "../views/anonymous/views/legal/Handler";
import Tos from "../views/anonymous/views/legal/views/tos/Handler";
import Privacy from "../views/anonymous/views/legal/views/privacy/Handler";
import ReturnPolicy from "../views/anonymous/views/legal/views/return-policy/Handler";
import Warranty from "../views/anonymous/views/legal/views/warranty/Handler";
import Compliance from "../views/anonymous/views/legal/views/compliance/Handler";
import Trademark from "../views/anonymous/views/legal/views/trademark/Handler";
import Open from "../views/anonymous/views/legal/views/open/Handler";

import Gateway from "../views/anonymous/views/gateway/Handler";
import Address from "../views/anonymous/views/address/Handler";
import Verify from "../views/anonymous/views/verify/Handler";
import Cancel from "../views/anonymous/views/cancel/Handler";

import StyleGuide from "../views/anonymous/views/sg/Handler";

// Talkable integration
import Invite from "../views/anonymous/views/invite/Handler";

// Year in Review
import YearInReview from "../views/anonymous/views/yearinreview/Handler";
let routes = (
    <Route name="home" path="/" handler={App}>

        <Route name="your-home" handler={YourHome}/>
        <Redirect from="in-the-home" to="your-home"/>
        <Route name="features" handler={Features}/>
        <Route name="technology" handler={Technology}/>
        <Route name="support" handler={Help}/>
        <Redirect from="help" to="support"/>

        <Route name="legal" handler={Legal}>
            <Route name="tos" handler={Tos}/>
            <Route name="privacy" handler={Privacy}/>
            <Route name="return-policy" handler={ReturnPolicy}/>
            <Route name="warranty" handler={Warranty}/>
            <Route name="compliance" handler={Compliance}/>
            <Route name="trademark" handler={Trademark}/>
            <Route name="open" handler={Open}/>
            <DefaultRoute handler={Tos}/>
        </Route>

        <Redirect from="privacy" to="privacy"/>

        <Route name="our-story" handler={OurStory}/>
        <Redirect from="about-us" to="our-story"/>
        <Route name="jobs" ignoreScrollBehavior={true} handler={Jobs}/>
        <Redirect from="join" to="jobs"/>
        <Redirect from="careers" to="jobs"/>
        <Route name="press" handler={Press}/>
        <Route name="app" handler={AppRoute}/>
        {/*<Route name="pro" handler={Pro}/>*/}
        <Redirect from="requirements" to="app" />
        <Redirect from="details" to="technology"/>

        {/*<Route name="sg" path="/utils/sg" handler={StyleGuide}/>*/}
        <Route name="gateway" handler={Gateway}/>
        <Route name="address" handler={Address}/>
        <Route name="verify" handler={Verify}/>
        <Route name="cancel" handler={Cancel}/>
        <Route name="invite" handler={Invite}/>
        <Route name="2016" handler={YearInReview}/>

        <DefaultRoute handler={Root}/>
        <NotFoundRoute handler={App404}/>
    </Route>
);

export default routes;



/** WEBPACK FOOTER **
 ** ./app/config/Routes.js
 **/